import ztComponent from './ztAccordion.vue'
import ztComponentChild from './ztAccordionItem.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
  Vue.component(ztComponentChild.name, ztComponentChild)
}
